/**
 * Thread Subscriptions Service (feature #62)
 * API calls for following / unfollowing a message thread (by its root message).
 */

import apiClient from './api.client';
import type { ApiResponse } from '@/types/api.types';

/**
 * Whether the current user follows the thread rooted at `messageId`.
 */
export const getSubscription = async (messageId: string): Promise<boolean> => {
  const response = await apiClient.get<ApiResponse<{ subscribed: boolean }>>(
    `/threads/${messageId}/subscription`
  );
  return response.data.data?.subscribed ?? false;
};

/**
 * Follow the thread rooted at `messageId`.
 */
export const subscribeToThread = async (messageId: string): Promise<void> => {
  const response = await apiClient.post<ApiResponse>(`/threads/${messageId}/subscribe`);
  if (response.data.status === 'error') {
    throw new Error(response.data.error || 'Failed to subscribe to thread');
  }
};

/**
 * Unfollow the thread rooted at `messageId`.
 */
export const unsubscribeFromThread = async (messageId: string): Promise<void> => {
  const response = await apiClient.delete<ApiResponse>(`/threads/${messageId}/subscribe`);
  if (response.data.status === 'error') {
    throw new Error(response.data.error || 'Failed to unsubscribe from thread');
  }
};
